import References from '../../../helpers/Reference';
import AuthService from '../../../helpers/auth';
import {sprintf, getBaseLog} from '../../../helpers/helpers';

import dayjs from 'dayjs';

export const MAX = {
    '10M': [0, 0.2, 1, 3, 5, 8, 10, 12],
    '3H': [0, 0.2, 2, 5, 10, 15, 20, 30]
};
const QUANTS = 8;


export const loadFields = ( start, end, bounds, zoom, agg) => {
    const southWest = bounds.getSouthWest();
    const northEast = bounds.getNorthEast();
    let url = sprintf(
        References.api.get_precipitation_field,
        encodeURIComponent(dayjs(start, References.dateTimeFormat).format()),
        encodeURIComponent(dayjs(end, References.dateTimeFormat).format()),                
        southWest.lat,
        southWest.lng,
        northEast.lat,
        northEast.lng,
        zoom
    );
    if (agg !== '10M')
        url += '&period=' + agg;
    return AuthService.fetch(url)
    .then(res => res.json());
}

export const parseFields = (data) => {
    const keys = Object.keys(data)
    if (keys.length === 0)
        return [];
    
    const key = keys[0];
    const fields = data[key];
    return Object.keys(fields).map((key) => {
        let item = JSON.parse(fields[key]);
        item.time = key;
        //return {[key]: JSON.parse(fields[key])}
        return item;
    })
}

export const polygonTransperent = (value, agg) => {
    const quantNum = MAX[agg].indexOf(value) + 1;
    const pow = 1 / 1.25;
    return Math.pow(quantNum, pow) * 100 / Math.pow(QUANTS, pow);
    //return Math.sqrt(quantNum) * 100 / Math.sqrt(QUANTS);    
    /*const log = getBaseLog(2, quantNum ) + 4;
    const maxLog = getBaseLog(2, QUANTS ) + 4;
    console.log(quantNum, log * 100 / maxLog);    
    return log * 100 / maxLog;
    //return value * 100 / (MAX / QUANTS);*/
}   

export const getLegendTitle = (agg, quant) => {
    if (quant + 1 === QUANTS)
        return `${References.dictionary.precipitation_label[quant]}: > ${MAX[agg][quant]} ${References.mchs.precipitation.unit}`;

    return `${References.dictionary.precipitation_label[quant]}: ${MAX[agg][quant]} - ${MAX[agg][quant + 1]} ${References.mchs.precipitation.unit}`

}

